import { IconButton } from '@atlaskit/button/new';
import CloseIcon from '@atlaskit/icon/core/close';
import React, { FunctionComponent } from 'react';

interface FieldValueRemoveButtonProps {
  testId: string;
  onItemDelete: () => void;
  autoFocus?: boolean | undefined;
}

export const FieldValueRemoveButton: FunctionComponent<FieldValueRemoveButtonProps> = ({
  testId,
  onItemDelete,
  autoFocus,
}) => {
  return (
    <IconButton
      testId={testId}
      data-popover-edit-focus
      appearance="subtle"
      icon={CloseIcon}
      label=""
      onClick={onItemDelete}
      autoFocus={autoFocus}
    />
  );
};
